import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useScrollRestore from '../../hooks/useScrollRestore';

import {
  fetchTasks
} from '../../features/tasks';

import {
  fetchHolidays
} from '../../features/holidays';

import CustomerSection from './customer-section';
import CalendarDateSelector from '../employee-calendar/calendar-date-selector';
import CalendarDateLine from '../employee-calendar/calendar-date-line';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {selectSettings} from '../../features/settings';
import {
  fetchCustomers, selectCustomers, sortCustomersByTitle, filterCustomersByActive
} from '../../features/customers';
import {fetchUsers} from '../../features/users';
import {
  fetchJobs, filterJobsByActive, filterJobsByCustomer
} from '../../features/jobs';

import {splitDaysInWorkAndWeekend} from '../../utils/date-utils';

const JobCalendar = () => {
  const dispatch = useDispatch();

  // const departments = useSelector(state => {
  //   return state.departments.items;
  // });
  //
  // const departmentsStatus = useSelector(
  //     state => { return state.departments.status; });

  const tasksStatus = useSelector(
      state => { return state.tasks.status; });

  const holidaysStatus = useSelector(
      state => { return state.holidays.status; });

  const allCustomers = sortCustomersByTitle(
      filterCustomersByActive(
          useSelector(state => {
            return selectCustomers(state);
          }, 'desc')
          , 1)
  );

  const jobs = useSelector(state => {
    return state.jobs.items;
  });

  const customers = allCustomers.filter((customer) => {
    return filterJobsByActive(filterJobsByCustomer(jobs, customer.uid)).length >
        0;
  });

  const customersStatus = useSelector(
      state => { return state.customers.status; });

  const jobsStatus = useSelector(
      state => { return state.jobs.status; });

  const userStatus = useSelector(
      state => { return state.users.status; });

  const settings = useSelector(selectSettings);

  const refDateLine = useRef(null);
  const refMain = useRef(null);

  useScrollRestore('job-calendar', refMain);

  const onScrollDateLine = (e) => {
    refMain.current.scrollLeft = refDateLine.current.scrollLeft;
  };

  const onScrollMain = (e) => {
    refDateLine.current.scrollLeft = refMain.current.scrollLeft;

    /* Namensspalte weggescrollt? Dann die Zeilen-Balken einblenden */
    refMain.current.classList.toggle('calendar-scroll--scrolled',
        refMain.current.scrollLeft > settings.cardWidth);
  };

  useEffect(() => {
    // if (customersStatus === 'idle') {
    //   dispatch(fetchDepartments());
    // }

    if (tasksStatus === 'idle') {
      dispatch(fetchTasks());
    }

    if (holidaysStatus === 'idle') {
      dispatch(fetchHolidays());
    }

    if (customersStatus === 'idle') {
      dispatch(fetchCustomers());
    }

    if (jobsStatus === 'idle') {
      dispatch(fetchJobs());
    }

//    dispatch({type: 'customers/sortByName'});

    if (userStatus === 'idle') {
      dispatch(fetchUsers());
    }
// eslint-disable-next-line
  }, []);

  // [departmentsStatus, tasksStatus, holidaysStatus, customersStatus, dispatch]

  const days = settings.displayDurationWeeks * 7;
  const [workdays, weekendDays] = splitDaysInWorkAndWeekend(days, settings.date);

  const cardContainerWidth = (
      + (33 * 2)
      + settings.cardWidth // name column
      + settings.cardWidth // none day column
      + (workdays * (settings.cardWidth))
      + (weekendDays * (settings.holidayCardWidth))
      + 5 // better scale
  );

  return (
      <div style={{paddingTop: '43px'}}>

        <div style={{
          position: 'fixed',
          top: '73px',
          width: '100%',
          zIndex: 200,
          background: 'white'
        }}>
          <Container>
            <Row>
              <Col className="my-3">
                <CalendarDateSelector/>
              </Col>
            </Row>
          </Container>
        </div>

        <div style={{
          position: 'relative',
          top: '0',
          background: 'white',
          width: '100%'
        }}>

          <div className="shadow" ref={refDateLine} onScroll={onScrollDateLine}
               style={{
                 position: 'fixed',
                 zIndex: 100,
                 width: '100%',
                 overflow: 'hidden',
                 backgroundColor: 'white'
               }}>
            <div style={{
              position: 'relative',
              width: cardContainerWidth + 'px'
            }}>
              <CalendarDateLine/>
            </div>
          </div>


          <div ref={refMain} onScroll={onScrollMain} className="calendar-scroll"
               style={{
                 width: '100%',
                 overflowY: 'scroll',
                 top: '50px',
                 position: 'relative'
               }}>

            <div style={{
              position: 'relative',
              width: cardContainerWidth + 'px',
            }}>

              {customers.map((customer, index) => (
                  <CustomerSection key={index} customer={customer}/>
              ))}

            </div>
          </div>
        </div>
      </div>
  );

};

export default JobCalendar;
